module.exports = __webpack_public_path__ + "img/T5-B-rc14.76aefee9.png";